export enum JoinSteps {
  Initialize = 'initialize',
  Start = 'start',
  Email = 'email',
  EmailVerification = 'emailVerification',
  Password = 'password',
  CredentialsSubmitted = 'credentialsSubmitted',
  Joining = 'joining',
  Finished = 'finished',
  Unjoinable = 'unjoinable',
  Inexistent = 'inexistent',
  FromSSO = 'fromSSO',
  EmailSent = 'emailSent',
}
